import React, {useRef, useEffect, useState} from 'react';
import { XText } from "./XText"
import {useNodes} from './NodeContext'
import {smoothScrollTo} from "../utils/"
import { runQuery } from '../utils';
import { Tooltip} from 'react-tooltip';
import Nav from 'react-bootstrap/Nav';
import {FaComments, FaEdit, FaInfo, FaBook, FaSearch} from 'react-icons/fa';
import { Spinner } from "../Spinner/Spinner"
import { getSourcesInfo, getModernCitation } from "./queries";
import { any } from 'prop-types';
import { range } from 'mathjs';
import {Citation} from "../Citation/Citation"



export interface MyComponentProps {
  // Define your prop types here
   nodes: []
   number?: number
   id: string
   type?: string // default quote or ref
   index: string
   selectedIndices: any,
   relatedSelectedIndices: any
   commentAnnotationIndices: any
   variantIndexListIndices: any
   ftype?: string
}

export const XQuote: React.FC<MyComponentProps> = (props) => {
  const keyPrefix = props.ftype === "secondary" ? "sec-" : ""
  const {info, handleChangeInfo, handleChangePreviewInfo, previewInfo, relatedElements, setRelatedElements, wordCountMap, itemRelatedExpressions, hoverFocus} = useNodes();
  const qRef = useRef<HTMLDivElement>(null);
  const isFocus = info.resourceid.includes(props.id) ? true : false
  const isRelated = relatedElements.includes(props.id) ? true : false
  const style = isFocus || isRelated ? {"backgroundColor": "yellow"} : {"cursor": "pointer"}
  const [sources, setSources] = useState<any[]|undefined>(undefined)
  const [modernCitations, setModernCitations] = useState<any[]|undefined>(undefined)
  const [isReferenceTo, setIsReferenceTo] = useState<any[]>([])
  const [currentStyle, setCurrentStyle] = useState<any>({})  
  
  //console.log("itemRelatedExpressions", itemRelatedExpressions)
  useEffect(() => {
    const style: any = {}
    //console.log("test", props.id)
    // console.log(itemRelatedExpressions)
    if (itemRelatedExpressions.some(item => item.referringResource === props.id) && hoverFocus.length === 0){
      style["backgroundColor"] = "rgba(0, 255, 0, 0.2)"
    }
    setCurrentStyle(style)
    // NOTE the check for changes on itemRelatedExpressions and hoverFocus
    // are checks on arrays; I think this can cause some kind of problem 
    // since the array reference could change even though the contest is the same
    // right now it seems to be working ok
  }, [itemRelatedExpressions, hoverFocus])


  const getSources = () => {
    setModernCitations([])
    setSources([])
    const elementExpressionResourceId = props.id
    runQuery(getSourcesInfo(elementExpressionResourceId)).then((d: any) => {
      const sources: any[] = []
      const isReferenceToArray: any[] = []
      if (d.data.results.bindings.length > 0){
        console.log("d", d.data.results)
        d.data.results.bindings.forEach((source: any) => {
          const sourceObject = {
            resourceid: source.cexpression.value,
            expressionid: source.cexpression.value,
            manifestationid: source.cmanifestation.value,
            transcriptionid: source.ctranscription.value,
            level: source.level.value,
            structureType: source.structureType.value.split("/resource/")[1],
            rangeStart: source.rangeStart?.value,
            rangeEnd: source.rangeEnd?.value,
            author: source.author?.value, 
            authorTitle: source.authorTitle?.value,
            longTitle: source.longTitle?.value,
            isReferenceTo: source.isReferenceTo?.value,
            }
            // ...(source.eItemParent &&  {
            //   itemInfo: {
            //     expressionid: source.eItemParent.value,
            //     manifestationid: source.mItemParent.value,
            //     transcriptionid: source.tItemParent.value,
            // },
            // }),
            // topLevelInfo:{
            //   expressionid:source.cexpression.value,
            //   manifestationid: source.cexpression.value,
            //   transcriptionid: source.cexpression.value,
            //   author: source.author.value, 
            //   authorTitle: source.authorTitle.value
            // }
          sources.push(sourceObject)
          isReferenceToArray.push(source.isReferenceTo?.value)
        })
        console.log("isReferenceToArray", isReferenceToArray)
        setIsReferenceTo(isReferenceToArray)
        setSources(sources)
      }
      else{
        runQuery(getModernCitation(elementExpressionResourceId)).then((d: any) => {
          console.log("d", d) 
          if (d.data.results.bindings.length > 0){
            const source = d.data.results.bindings[0]
            const sourceObject = {
              resourceid: elementExpressionResourceId,
              modernCitation: source.modernCitation?.value,
              isReferenceTo: source.isReferenceTo?.value,
            }
            sources.push(sourceObject)
            isReferenceToArray.push(source.isReferenceTo?.value)
          }
          console.log("isReferenceToArray", isReferenceToArray)
          setIsReferenceTo(isReferenceToArray)
          setModernCitations(sources)
        })
      }
      
    })
  }

  const scrollToElement = () => {
    if (qRef.current) {
      //qRef.current.scrollIntoView({ behavior: 'smooth' });
      smoothScrollTo(qRef.current, 1000); // 1000ms = 1 second
    }
  };

  useEffect(() => {
    if (isFocus) {
      scrollToElement();
    }
  }, [isFocus]);


  const displaySources = () => {
    if (sources && sources.length > 0){
      return sources?.map((source: any, idx: number) => {
        let selectionRangeObject;
        if (source.rangeStart){
          selectionRangeObject = {
            "wordRange": {
              "start": parseInt(source.rangeStart), 
              "end": parseInt(source.rangeEnd)
              }
            }
        }
        const previewId = (source?.rangeStart && source?.rangeEnd) ? source.expressionid + "@" + source.rangeStart + "-" + source.rangeEnd : source.expressionid
        return (
        <p className="lbp-span-link" key={"entry-" + keyPrefix + idx} onClick={() => {handleChangePreviewInfo(previewId, "refQuote"); handleChangeInfo(props.id + info.focusInfo.mtFocus)}}>
          {source.authorTitle && <span>{source.authorTitle + ", "}</span>}
          {source.longTitle && <span>{source.longTitle}</span>}
        </p>
        )
        // <Citation citationStyle="minimal" showGitHubEdit={false} 
        //         tresourceid={source.focusInfo.transcriptionid}
        //         selectionRange={selectionRangeObject}/>)
      })
    }
    else if (modernCitations && modernCitations.length > 0){

      return modernCitations?.map((mc: any, idx2: number) => {
        return (
          <p key={"entry2-" + keyPrefix + idx2}>
            {mc.modernCitation ? <span>{mc.modernCitation}</span> :  <span className="lbp-span-link" onClick={() => handleChangeInfo(props.id + info.focusInfo.mtFocus)}>Click to Focus</span>}
          </p>
        )
      })
    }
    else {
      return (null);
    }
  }
  
  

  return (
    <>
    <span ref={qRef} style={currentStyle}> 
      {props.type !== "ref" && <span>"</span>}
      <span style={style}>
      <XText nodes={props.nodes} selectedIndices={props.selectedIndices} relatedSelectedIndices={props.relatedSelectedIndices} commentAnnotationIndices={props.commentAnnotationIndices} variantIndexListIndices={props.variantIndexListIndices} index={props.index} ftype={props.ftype}/>
      </span>
      {props.type !== "ref" && <span>"</span>} 
      {/* <span  onMouseEnter={() => {handleChangePreviewInfo(props.id)}} data-tooltip-id={"tooltip-" + props.id}> * </span> */}
      <span className="lbp-span-link" onMouseEnter={() => {getSources()}} onClick={() => {handleChangeInfo(props.id + info.focusInfo.mtFocus); setRelatedElements(isReferenceTo)}} data-tooltip-id={"tooltip-" + props.id}> * </span>
    </span>
    <Tooltip id={"tooltip-" + props.id} clickable={true} place="bottom">
        {(sources || modernCitations) && displaySources()}
        {/* replacing the below with the above because I'm not sure the else part of the conditional is necessary
        and in the secondary view it seemed to be leading ot a duplication of the tooltip window
         {(sources || modernCitations) ? displaySources() : <span className="lbp-span-link" onClick={() => handleChangeInfo(props.id + info.focusInfo.mtFocus)}>Click to Focus</span>} */}


          {/* <Nav>
              <Nav.Link onClick={() => {setCurrentResourceid(previewResourceId)}}><FaInfo/></Nav.Link>
              <Nav.Link><FaComments/></Nav.Link>
              <Nav.Link><FaEdit/></Nav.Link>
              <Nav.Link><FaSearch/></Nav.Link>
              <Nav.Link><FaBook/></Nav.Link>
            </Nav> */}
    </Tooltip>
    </>
  )
}